import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { BrowserState } from './state';

const defaultState: BrowserState = {
  folders: [],
};

export const browserModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
